const TASK_TIME_ZONE = "America/Toronto";

export const taskCalendarDate = (timestamp: string | Date, timeZone = TASK_TIME_ZONE): string => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(typeof timestamp === "string" ? new Date(timestamp) : timestamp);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? "";

  return `${value("year")}-${value("month")}-${value("day")}`;
};

const isWeekday = (date: Date): boolean => {
  const day = date.getUTCDay();
  return day !== 0 && day !== 6;
};

export const calculateTaskDeadline = (
  firstAssignedAt: string | null | undefined,
  durationBusinessDays: number | null | undefined,
  isBusinessDay: (date: Date) => boolean = isWeekday,
): string | undefined => {
  if (!firstAssignedAt || durationBusinessDays == null || durationBusinessDays < 0)
    return undefined;

  return addBusinessDays(taskCalendarDate(firstAssignedAt), durationBusinessDays, isBusinessDay);
};

const addBusinessDays = (
  date: string,
  days: number,
  isBusinessDay: (date: Date) => boolean,
): string => {
  const [year, month, day] = date.split("-").map(Number) as [number, number, number];
  const current = new Date(Date.UTC(year, month - 1, day));
  let remaining = days;

  while (remaining > 0) {
    current.setUTCDate(current.getUTCDate() + 1);
    if (isBusinessDay(current)) remaining -= 1;
  }

  return current.toISOString().slice(0, 10);
};
